// Parent Modules
import { hero } from './modules/hero';
import { heroLs } from './modules/hero-location-search';
import { moduleMap } from './modules/map';
// import newsletterSignup from './modules/newsletter-signup';
import { promo } from './modules/promo';
import { promoSlider } from './modules/promo-slider';
import { imageSlider } from './modules/image-slider';
import { videoPlayer } from './modules/video-player';
import { moduleSpacesFeed } from './modules/private-event-spaces-feed';
import { moduleMenus } from './modules/menus';
import { faqsJS } from './modules/faqs';
import { tabContentSliders } from './modules/tab-content';
import { coimg } from './modules/content-over-image';
import { mediaWithCaption } from './modules/media-with-caption';
import { heroContentImages } from './modules/hero-content-images';

import { hoverVideo } from './functions/hover-video';
import { inlineVideo } from './functions/inline-video';
import { popupNav } from './functions/popup-nav';
import { closePopupsButtonWatcher, triggerCustomPopups } from './functions/popups';
// import { urlParams } from './functions/url-params';
import { locationScroll } from './functions/location-scroll';
import { locationFilters } from './functions/location-filters';
import { locationSearch } from './functions/location-search';
import { preferenceCenter } from './functions/preference-center';

//Child Theme Specific JS
import './components/atreemoForm';

import { urlParams } from './functions/url-params';
import { moduleFuseFeed } from './modules/fuse-feed';
import { cardSlider } from './modules/card-slider';
import { audioPlayer } from './components/audio-player';
//import { toggleCursor } from './components/cursor';
import { fadeOnScroll } from './components/fade-on-scroll';
//import { smoothScroll } from './components/smooth-scroll';
import { header } from './components/header';
import { bookingWidget } from './functions/booking-widget';
import { blogFeed } from './modules/blog-feed';
import { homePagePreloader } from './functions/preloader';

export default initJS = () => {
	document.querySelector('body').classList.remove('no-js');
	document.querySelector('#js__body').classList.remove('no-js');

	//Modules
	hero();
	heroLs();
	cardSlider();
	moduleMap();
	promo();
	promoSlider();
	imageSlider();
	videoPlayer();
	moduleSpacesFeed();
	moduleFuseFeed();
	moduleMenus();
	faqsJS();
	blogFeed();
	tabContentSliders();
	coimg();
	mediaWithCaption();
	heroContentImages();

	//Global Parent Functions
	header();
	popupNav();
	bookingWidget();
	closePopupsButtonWatcher();
	triggerCustomPopups();
	urlParams();
	hoverVideo();
	inlineVideo();
	locationScroll();
	locationFilters();
	locationSearch();

	// Page Specific Functions
	homePagePreloader();
	preferenceCenter();

	fadeOnScroll();
	audioPlayer();
	//smoothScroll();
}